<div class="w-full h-full">
  <form nz-form [formGroup]="this.wsForm" *ngIf="this._mentionVm$ | async as vm">
    <om-mention
      label="Issue Field Pattern"
      [control]="this.wsForm"
      [suggestions]="vm.suggestions"
      [suggestionKey]="vm.suggestionKey"
      [notEmptyMentions]="true"
    ></om-mention>
  </form>
</div>
